import { apis } from '@doltech/core/lib/api/api.config';
import { getUserAnonymousId } from '@doltech/core/lib/auth/constants';
import { useSimpleLocalStorage } from '@doltech/core/lib/hooks/useSimpleLocalStorage';
import { isNil } from 'lodash';
import { useCreateStore, useProvider } from 'mobx-store-provider';
import React from 'react';
import { useQuery } from 'react-query';

import { DoExerciseProgressStore } from './do-exercise-progress-store.store';
import { useDoExerciseProgressContext } from './DoExerciseProgressContext';
import { EXERCISES_LOCAL_STORAGE_KEY } from './types';
import { useExerciseProgress } from './useSaveExcerciseProgress';
import { apiPublicUrls } from '@doltech/core/lib/api/api.public-urls';

export const withDoExerciseProgress = (Component) => (props) => {
  const Provider = useProvider(DoExerciseProgressStore);
  const store = useCreateStore(DoExerciseProgressStore);
  const [excercises, setExercises] = useSimpleLocalStorage(EXERCISES_LOCAL_STORAGE_KEY, {});
  const save = useExerciseProgress();
  const { pageId } = useDoExerciseProgressContext();

  const { data } = useQuery<any>(
    ['GET_EXERCICES_PROGRESS', pageId],
    async () => {
      const res = await apis.publicOnlineTestV2.get(apiPublicUrls.onlineTestV2.EXERCISES_PROGRESS, {
        pageId,
        sessionId: getUserAnonymousId(),
      });
      return res.data;
    },
    {
      enabled: !isNil(pageId),
    }
  );

  const lastPayload = React.useRef({});

  const persistDb = (exercise, forced) => {
    if (forced || !exercise.isViewResult) {
      const payload: any = {
        ...exercise.preparePayload(),
        pageId,
      };
      lastPayload.current[payload.exerciseId] = payload;
      save.mutate(payload);
    }
  };

  const saveProgressApi = (forced = false) => {
    store.multipleChoiceStores.forEach((exercise) => persistDb(exercise, forced));
    store.gapFillStores.forEach((exercise) => persistDb(exercise, forced));
    store.shortAnswerStores.forEach((exercise) => persistDb(exercise, forced));
    store.gapFillWithHintStores.forEach((exercise) => persistDb(exercise, forced));
  };

  // const persistLocalStorage = (exercise) => {
  //   const newValue = { ...excercises, [exercise.id]: { ...exercise.preparePayload(), pageId } };
  //   if (!isEqual(newValue, excercises)) setExercises(newValue);
  // };

  // const saveProgressLocal = () => {
  //   store.multipleChoiceStores.forEach(persistLocalStorage);
  //   store.gapFillStores.forEach(persistLocalStorage);
  //   store.shortAnswerStores.forEach(persistLocalStorage);
  //   store.gapFillWithHintStores.forEach(persistLocalStorage);
  //   store.quizStores.forEach(persistLocalStorage);
  // };

  // const saveProgress = () => {
  //   saveProgressApi();
  // };

  // useInterval(saveProgress, pageId ? 30000 : null);

  React.useEffect(() => {
    if (!pageId) return;
    const hasLocalData = Object.keys(excercises).length > 0;

    if (hasLocalData) {
      store.init(Object.values(excercises));
      return;
    }

    // Case: after login -> push local data to BE then clean
    if (hasLocalData) {
      saveProgressApi(true);
      setExercises({});
    } else if (data?.content) {
      store.init(data.content);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pageId, data?.content]);

  return (
    <Provider value={store}>
      <Component {...props} />
    </Provider>
  );
};
